<div class="reports-header">
  <div class="container">
    <slot />
  </div>
</div>

<style>
  .reports-header {
    padding: 60px 0;
  }

  .reports-header :global(.arrow-link) {
    padding-bottom: 8px;
  }

  .reports-header :global(h1) {
    padding: 12px 0;
  }

  .reports-header :global(p) {
    padding: 10px 0;
  }

  @media (max-width: 767px) {
    .reports-header :global(h1) {
      font-size: 32px;
      font-size: 3.2rem;
      line-height: 38px;
      line-height: 3.8rem;
      padding-top: 0;
    }

    .reports-header :global(.arrow-link) {
      padding-bottom: 20px;
    }
  }

  @media (max-width: 850px) {
    .reports-header {
      padding: 30px 0;
      background: #2b2b2b;
    }
    .reports-header :global(h1),
    .reports-header :global(a:not(.report-button)),
    .reports-header :global(p),
    .reports-header :global(.arrow-link) {
      color: white;
    }
    .reports-header :global(.arrow-link svg) {
      color: rgba(255, 255, 255, 0.5);
    }

    .reports-header :global(a:not(.report-button)):hover,
    .reports-header :global(.arrow-link):hover {
      opacity: 0.7;
    }
  }
</style>
